module.exports = __webpack_public_path__ + "814482b15351d2c423d28a2b580ed2a4.png";